import {
  mapState,
  mapMutations
} from 'vuex'
import api from '../../service/services'

export default {
    data() {
      return {
        // qrcode: '',
        wal: {
            sku_id: 3,
            image_name: 'wallet',
            color: 'badge-warning',
            goto: 'Wallet',
            image_path: require('../../assets/E-wallet.png'),
            title_name: [
              {
                name_id: 0,
                name: 'E-wallet',
                say: 'Payment By E-wallet'
              },
              {
                name_id: 1,
                name: 'กระเป๋าเงิน',
                say: 'ชำระเงินผ่านช่องทางกระเป๋าเงินออนไลน์'
              },
              {
                name_id: 2,
                name: '钱包',
                say: '通过在线钱包付款'
              }
            ]
          }
      }
    },
    // computed: {
    //   ...mapState(['isLoading']),
    // },
    // methods: {
    //   checkTime() {
    //     this.$store.state.loopWallet = setInterval(() => {
    //       this.checkWallet()
    //       if (this.time == 0) {
    //         clearInterval(this.$store.state.loopWallet)
    //       }
    //     }, 1000)
    //   },
    //   checkWallet() {
    //     const header = {
    //       headers: {
    //         'x-access-token': this.$store.state.accessToken
    //       }
    //     }
    //     var payload = {
    //       vending_uuid: this.$store.state.UUID,
    //       order_uuid: this.$store.state.txn_id,
    //       amount: parseFloat(this.$store.state.total),
    //       client_name: this.$store.state.config.client.branch,
    //       terminal_id: this.$store.state.config.vending.terminal_id,
    //       qr_tag: this.qrcode
    //     }
    //     api.checkPromptpay(
    //       payload,
    //       header,
    //       result => {
    //         console.log(result)
    //         if (result.Response === 'success') {
    //           if (result.data.status == 'completed' && (result.data.method == "pay9_debit" || result.data.method == "pay9_credit")) {
    //             console.log('completed = ', result)
    //             this.$store.state.time = 0
    //             this.$store.state.PaymentType = 4
    //             // alert('ชำระ promptpay = ' + JSON.stringify(result))
    //           }
    //         }
    //       },
    //       error => {
    //         alert(JSON.stringify(error))
    //       }
    //     )
    //   }
    // },
    mounted() {
      console.log('wallet ready!!')
      // this.checkTime()
    }
  };



// WEBPACK FOOTER //
// ./src/js/type/wallet.js